const BORDER_RADII = {
  S: "4px",
  M: "6px",
  L: "8px",
  XL: "12px"
};
const COLORS = {
  BLACK: "#000000",
  BRAND_PRIMARY: "#E54439",
  RED: "#EB5757",
  CHARCOAL: "#313131",
  CLOUD: "#F0F0F0",
  DUNE: "#F2EFEE",
  FERN: "#6EA76D",
  HONEYDEW: "#F9FBF9",
  LIGHT_CLOUD: " #F7F7F7",
  NIMBUS: "#AEAEAE",
  OLIVE_3: "#5A9488",
  ORANGE: "#FBD283",
  SHARK: "#DCDCDB",
  WHITE: "#FFFFFF",
  WHITE_SMOKE: "#F4F4F4",
  EC_GRAY: "#ECECEC",
  SMOKE: "#6E6E6D",
  LINEN: "#F5F2ED",
  LINEN_DARK: "#DFD7C8"
};
const FONT_SIZES = {
  HXL: "56px",
  H1: "40px",
  H2: "32px",
  H3: "24px",
  H4: "18px",
  H5: "14px",
  SUBHEAD: "14px",
  // Everything below this is old and should be replaced with new names
  XS: "12px",
  S: "14px",
  M: "16px",
  L: "18px",
  XL: "20px",
  XL2: "22px",
  XXL: "24px",
  XXL2: "28px",
  "3XL": "32px",
  "4XL": "40px"
};
const FONT_WEIGHTS = {
  REGULAR: 400,
  MEDIUM: 500,
  BOLD: 700,
  BLACK: 900
};
const LINE_HEIGHTS = {
  XS: "10px",
  S: "14px",
  M: "16px",
  L: "20px",
  L2: "22px",
  // Since there's no consistency yet
  L3: "24px",
  // Since there's no consistency yet
  XL: "28px",
  XXL: "32px",
  "3XL": "34px",
  "4XL": "40px"
};
const SPACING = {
  PXL: "22px",
  PL: "18px",
  P: "16px",
  PS: "14px",
  // Everything below is deprecated
  XXS: "6px",
  XS: "8px",
  S: "10px",
  M: "16px",
  L: "20px",
  XL: "24px",
  XXL: "28px"
};
const EatClubTheme = {
  BORDER_RADII,
  COLORS,
  FONT_SIZES,
  FONT_WEIGHTS,
  LINE_HEIGHTS,
  SPACING
};
export {
  BORDER_RADII,
  COLORS,
  EatClubTheme,
  FONT_SIZES,
  FONT_WEIGHTS,
  LINE_HEIGHTS,
  SPACING
};
//# sourceMappingURL=EatClubTheme.js.map
